import StudentList from './StudentList/StudentList'
import StudentEdit from './StudentEdit/StudentEdit'
import StudentIcon from '@material-ui/icons/LocalLibrary';

export default {
  list: StudentList,
  edit: StudentEdit,
  icon: StudentIcon,
  options: { label: 'Student' }
}